import { render, staticRenderFns } from "./SolveErrors.vue?vue&type=template&id=82b234e0&scoped=true&"
import script from "./SolveErrors.vue?vue&type=script&lang=js&"
export * from "./SolveErrors.vue?vue&type=script&lang=js&"
import style0 from "./SolveErrors.vue?vue&type=style&index=0&id=82b234e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b234e0",
  null
  
)

export default component.exports